module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bccKZ"))).then(() => parcelRequire('hEqeo'));